<template>
  <div class="flex gap-2 justify-center" data-test-id="vf-media-gallery-pagination">
    <div
      v-for="page in pages"
      :key="page"
      :aria-current="page === activePage + 1 || undefined"
      class="b b-grey-40 rounded-full h-2 w-2"
      :class="{ 'bg-grey-10 b-grey-10 !b-black': page === activePage + 1 }"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  activePage: number
  pages: number
}>()
</script>
